import Vue from "vue";
import Router from "vue-router";
// import store from "@/store";
import portalRoutes from "./portal"; // 门户站点页面
// import "@/utils/stat";
Vue.use(Router);

export const constantRoutes = [
  {
    path: "/",
    redirect: "/dashboard"
  },
  {
    path: "/login",
    redirect: "/home"
  },
  // {
  //   path: "/home",
  //   name: "Home",
  //   meta: { title: "看板" /* keepAlive: true */ },
  //   component: () =>
  //     import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/index")
  // },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Home")
  },
  {
    path: "/portal",
    redirect: "/home", // 门户站点首页路径
    name: "Portal",
    meta: { title: "首页" },
    component: () => import(/* webpackChunkName: "portal" */ "@/views/portal"),
    children: [...portalRoutes]
  },
  {
    path: "/about",
    name: "About",
    component: () => import(/* webpackChunkName: "about" */ "@/views/About.vue")
  },
  {
    path: "/protocol",
    name: "Protocol",
    component: () =>
      import(/* webpackChunkName: "protocol" */ "@/views/protocol/index.vue")
  },
  {
    path: "/report/*",
    name: "Report",
    component: () =>
      import(/* webpackChunkName: "frame" */ "@/layout/components/frame.vue"),
    meta: { frame: true }
  },
  {
    path: "/404",
    name: "err404",
    meta: {
      withoutAuth: true
    },
    component: () =>
      import(/* webpackChunkName: "404" */ "@/views/error/404.vue")
  },
  {
    path: "/autoLogin",
    name: "autoLogin",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/login/autoLogin.vue")
  },
  {
    path: "/model-fastview",
    name: "modelFastview",
    component: () =>
      import(
        /* webpackChunkName: "modelFastview" */ "@/views/model-fastview/index.vue"
      )
  }
];

const createRouter = () =>
  new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: constantRoutes
  });

const router = createRouter();

// let childrenPath = [];
router.beforeEach((to, from, next) => {
  // const microAppRoutes = store.getters.microAppRoutes;
  // childrenPath = microAppRoutes.map(item => item.path);
  // console.log(to.path, childrenPath);
  // if (to.name) {
  //   // 有 name 属性，说明是主应用的路由
  //   next();
  // } else if (childrenPath.some(item => to.path.indexOf(item) > -1)) {
  //   next();
  // } else if (to.path !== "/404") {
  //   next({ path: "/404" });
  // } else {
  //   next();
  // }
  if (to.path !== from.path) {
    // store.dispatch("tracer/pushState", {
    //   path: from.path,
    //   title: from.meta && from.meta.title
    // });
  }
  next();
});

// 重置路由
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
